import { apiFetch } from "../http";
const ALL_TIME_VARIANTS = new Set(["за все время", "за всё время", "all", "all time"]);
const normalizeYear = (year) => String(year !== null && year !== void 0 ? year : "").trim();
const isAllTimeYear = (year) => {
    const normalized = normalizeYear(year).toLowerCase().replace(/ё/g, "е");
    if (!normalized)
        return true;
    return ALL_TIME_VARIANTS.has(normalized);
};
const buildStatisticsQuery = (year, userId) => {
    const query = new URLSearchParams();
    const normalizedYear = normalizeYear(year);
    if (normalizedYear && !isAllTimeYear(normalizedYear))
        query.set("year", normalizedYear);
    if (userId !== undefined && userId !== null && String(userId).trim()) {
        query.set("user_id", String(userId).trim());
    }
    const value = query.toString();
    return value ? `?${value}` : "";
};
const getErrorMessage = (data, fallback) => {
    if (!data)
        return fallback;
    return data.error || data.detail || data.message || fallback;
};
export async function getUserStatistics(params) {
    const query = buildStatisticsQuery(params.year, params.userId);
    const data = await apiFetch(`/travel/api/get_user_statistics/${query}`, {
        baseUrl: params.baseUrl,
        token: params.token,
        method: "GET"
    });
    if ((data === null || data === void 0 ? void 0 : data.success) === false) {
        throw new Error(getErrorMessage(data, "Failed to load user statistics"));
    }
    return data;
}
